import { useEffect, useState } from "react";
import type { FC, FormEventHandler } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  CircularProgress,
  InputLabel,
  Stack,
} from "@mui/material";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { useEditUserMutation } from "store/current-user/current-user.api";
import { currentUserActions } from "store/current-user/current-user.slice";
import {User} from "store/user/user.model";
import {SwitchButton} from "./SwitchButton";

export const EditUserGenderMenu: FC = () => {
  const [gender, setGender] = useState<"Male" | "Female" | null>(null);

  const { editUserGenderMenu } = useShallowPickSelector("app", [
    "editUserGenderMenu",
  ]);
  const { user } = useShallowPickSelector("currentUser", ["user"]);

  const dispatch = useDispatch();

  const [editUser, { isLoading, data }] = useEditUserMutation();

  useEffect(() => {
    if (user && user.gender) {
      setGender(user.gender);
    }
  }, [user]);

  useEffect(() => {
    if (data) {
      dispatch(currentUserActions.setUser(data));
      onClose();
    }
  }, [data]);

  const onClose = () => {
    dispatch(
      appActions.setEditUserGenderMenu({
        isOpen: false,
      })
    );
  };

  const onChangeGender = (value: "Male" | "Female") => {
    setGender(value);
  };

  const onSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    if (!user || !gender) return;
    editUser({
      userId: user.id,
      body: { gender },
    });
  };

  return (
    <BottomSheet
      title={"ویرایش جنسیت"}
      isOpen={editUserGenderMenu.isOpen}
      onClose={onClose}
    >
      <Stack component={"form"} onSubmit={onSubmit}>
        <Stack mx={3} mt={1} mb={6}>
          <InputLabel htmlFor={"gender"}>جنسیت</InputLabel>
          <SwitchButton
              value={gender}
              onChange={onChangeGender}
              items={
                [
                  { value: "Male", text: "پسر" },
                  { value: "Female", text: "دختر" },
                ] as { value: User["gender"]; text: string }[]
              }
          />
        </Stack>
        <Stack direction={"row"} mx={1} mb={-1}>
          <Button
            onClick={onClose}
            variant={"contained"}
            color={"secondary"}
            sx={{ flex: 1, mr: 1 }}
          >
            {"انصراف"}
          </Button>
          <Button
            type={"submit"}
            variant={"contained"}
            sx={{ flex: 3 }}
            disabled={!user || !gender || isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : "ثبت تغییرات"}
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  );
};
